export default __webpack_public_path__ + "geomanist-light-webfont.78ca3565e5ac494ebeb911e0f3419403.woff";